import * as Prismic from '@prismicio/client'
import {
  ScrollOverMediaDocument,
  ScrollstoryDocument,
  ThemeDocument,
} from '../../types.generated'

const prismicClient = Prismic.createClient(import.meta.env.VITE_PRISMIC_URL)

export const fetchScrollstory = async (
  id: string,
  lang: string
): Promise<ScrollstoryDocument> => {
  return await prismicClient.getByUID('scrollstory', id, { lang: lang })
}

export const fetchScrollOverMedia = async (
  id: string,
  lang: string
): Promise<ScrollOverMediaDocument | null> => {
  const response = await prismicClient.getByID(id, { lang: lang })
  if (response.type === 'scroll_over_media') {
    return response
  }
  console.error(`Fetched id ${id} was not of type scroll_over_media!`)
  return null
}

export const fetchTheme = async (
  uid: string
): Promise<ThemeDocument> => {
  return await prismicClient.getByUID('theme', uid, { lang: 'en-us' })
}
